export default __webpack_public_path__ + "static/media/logoLettering.7842e965.svg";